import { useEffect, useState } from "react";

export const useDeviceDetect = () => {
  const [device, setDevice] = useState<{
    isMobile: boolean | null;
    isDesktop: boolean | null;
    isTablet: boolean | null;
    isXiaomiBrowser: boolean | null;
  }>({ isMobile: null, isDesktop: null, isTablet: null, isXiaomiBrowser: null });

  useEffect(() => {
    const handleDeviceDetection = () => {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      const isMobile = /android|webos|iphone|ipod|blackberry|iemobile|opera mini/i.test(userAgent);
      const isTablet = /(ipad|tablet|playbook|silk)|(android(?!.*mobile))/i.test(userAgent);
      const isXiaomiBrowser = /MiuiBrowser/i.test(userAgent);
      setDevice(() => ({ isDesktop: !(isMobile || isTablet), isMobile, isTablet, isXiaomiBrowser }));
    };

    handleDeviceDetection();
    window.addEventListener("resize", handleDeviceDetection);
    return () => {
      window.removeEventListener("resize", handleDeviceDetection);
    };
  }, []);

  return device;
};
